module.exports = __webpack_public_path__ + "static/media/lizAnimation.1bf6a05d.gif";